import { useState } from 'react';
import ImageModal from './ImageModal';

interface PortfolioGalleryProps {
  activeCategory: string;
}

interface PortfolioItem {
  id: number;
  image: string;
  title: string;
  category: string;
  categoryId: string;
  description: string;
}

export default function PortfolioGallery({ activeCategory }: PortfolioGalleryProps) {
  const [selectedImage, setSelectedImage] = useState<PortfolioItem | null>(null);

  const portfolioItems: PortfolioItem[] = [
    {
      id: 1,
      image: 'https://public.readdy.ai/ai/img_res/97e0407014577ef894e251d67ffe9a18.jpg',
      title: '산업용 주조 목형',
      category: '목형 제작',
      categoryId: 'woodmold',
      description: '정밀한 산업용 주조를 위한 고품질 목형 제작'
    },
    {
      id: 2,
      image: 'https://readdy.ai/api/search-image?query=custom%20wooden%20packaging%20mold%20pattern%20industrial%20design%20professional%20product%20photography%20clean%20background%20precision%20manufacturing%20detailed%20wooden%20form%20packaging%20industry%20warm%20tones%20korean%20traditional%20craftsmanship&width=800&height=600&seq=portfolio-woodmold-2&orientation=landscape',
      title: '포장재 목형',
      category: '목형 제작',
      categoryId: 'woodmold',
      description: '포장재 생산을 위한 특수 목형 제작'
    },
    {
      id: 3,
      image: 'https://readdy.ai/api/search-image?query=wooden%20mold%20for%20automotive%20parts%20precision%20engineering%20industrial%20manufacturing%20clean%20background%20professional%20photography%20detailed%20craftsmanship%20warm%20wood%20tones%20korean%20quality&width=800&height=600&seq=portfolio-woodmold-3&orientation=landscape',
      title: '자동차 부품 목형',
      category: '목형 제작',
      categoryId: 'woodmold',
      description: '자동차 부품 생산용 정밀 목형'
    },
    {
      id: 4,
      image: 'https://readdy.ai/api/search-image?query=wooden%20pattern%20for%20metal%20casting%20foundry%20mold%20professional%20photography%20clean%20background%20industrial%20manufacturing%20precision%20craftsmanship%20warm%20tones%20korean%20traditional%20technique&width=800&height=600&seq=portfolio-woodmold-4&orientation=landscape',
      title: '금속 주조용 목형',
      category: '목형 제작',
      categoryId: 'woodmold',
      description: '금속 주조를 위한 전문 목형 제작'
    },
    {
      id: 5,
      image: 'https://readdy.ai/api/search-image?query=wooden%20mold%20for%20concrete%20products%20construction%20industry%20professional%20photography%20clean%20background%20precision%20manufacturing%20detailed%20craftsmanship%20warm%20wood%20tones%20korean%20quality%20work&width=800&height=600&seq=portfolio-woodmold-5&orientation=landscape',
      title: '콘크리트 제품 목형',
      category: '목형 제작',
      categoryId: 'woodmold',
      description: '콘크리트 제품 생산용 목형'
    },
    {
      id: 6,
      image: 'https://readdy.ai/api/search-image?query=wooden%20prototype%20mold%20for%20product%20development%20industrial%20design%20professional%20photography%20clean%20background%20precision%20craftsmanship%20detailed%20wooden%20form%20warm%20tones%20korean%20manufacturing&width=800&height=600&seq=portfolio-woodmold-6&orientation=landscape',
      title: '시제품 개발 목형',
      category: '목형 제작',
      categoryId: 'woodmold',
      description: '신제품 개발을 위한 시제품 목형'
    },
    {
      id: 7,
      image: 'https://readdy.ai/api/search-image?query=laser%20cut%20wooden%20wedding%20invitation%20card%20intricate%20floral%20pattern%20elegant%20design%20professional%20photography%20white%20background%20detailed%20laser%20cutting%20craftsmanship%20beautiful%20ornate%20details%20warm%20tones%20korean%20style&width=800&height=600&seq=portfolio-cutting-1&orientation=landscape',
      title: '청첩장 레이저 커팅',
      category: '레이저 커팅',
      categoryId: 'cutting',
      description: '섬세한 패턴의 고급 청첩장 제작'
    },
    {
      id: 8,
      image: 'https://readdy.ai/api/search-image?query=laser%20cut%20acrylic%20LED%20mood%20lamp%20modern%20design%20glowing%20light%20professional%20photography%20dark%20background%20intricate%20pattern%20decorative%20lighting%20contemporary%20style%20korean%20design&width=800&height=600&seq=portfolio-cutting-2&orientation=landscape',
      title: 'LED 무드등',
      category: '레이저 커팅',
      categoryId: 'cutting',
      description: '아크릴 레이저 커팅 LED 조명'
    },
    {
      id: 9,
      image: 'https://readdy.ai/api/search-image?query=laser%20cut%20wooden%20popup%20greeting%20card%20three%20dimensional%20design%20professional%20photography%20white%20background%20intricate%20cutting%20pattern%20creative%20craftsmanship%20warm%20tones%20korean%20style&width=800&height=600&seq=portfolio-cutting-3&orientation=landscape',
      title: '팝업카드',
      category: '레이저 커팅',
      categoryId: 'cutting',
      description: '입체적인 디자인의 팝업 카드'
    },
    {
      id: 10,
      image: 'https://readdy.ai/api/search-image?query=laser%20cut%20leather%20accessories%20fashion%20items%20professional%20photography%20clean%20background%20detailed%20cutting%20pattern%20elegant%20design%20warm%20brown%20tones%20korean%20craftsmanship&width=800&height=600&seq=portfolio-cutting-4&orientation=landscape',
      title: '가죽 악세사리',
      category: '레이저 커팅',
      categoryId: 'cutting',
      description: '정밀한 레이저 커팅 가죽 제품'
    },
    {
      id: 11,
      image: 'https://readdy.ai/api/search-image?query=laser%20cut%20wooden%20interior%20decoration%20wall%20art%20modern%20design%20professional%20photography%20clean%20background%20intricate%20pattern%20contemporary%20style%20warm%20wood%20tones%20korean%20design&width=800&height=600&seq=portfolio-cutting-5&orientation=landscape',
      title: '인테리어 소품',
      category: '레이저 커팅',
      categoryId: 'cutting',
      description: '레이저 커팅 인테리어 장식품'
    },
    {
      id: 12,
      image: 'https://readdy.ai/api/search-image?query=laser%20cut%20custom%20cake%20topper%20wedding%20decoration%20professional%20photography%20white%20background%20elegant%20design%20detailed%20cutting%20pattern%20beautiful%20ornate%20style%20korean%20craftsmanship&width=800&height=600&seq=portfolio-cutting-6&orientation=landscape',
      title: '맞춤 토퍼',
      category: '레이저 커팅',
      categoryId: 'cutting',
      description: '케이크 장식용 맞춤 토퍼 제작'
    },
    {
      id: 13,
      image: 'https://readdy.ai/api/search-image?query=laser%20engraved%20wooden%20photo%20portrait%20detailed%20wood%20burning%20art%20professional%20photography%20clean%20background%20personalized%20gift%20custom%20engraving%20high%20quality%20craftsmanship%20warm%20wood%20tones%20korean%20style&width=800&height=600&seq=portfolio-marking-1&orientation=landscape',
      title: '우드포토 각인',
      category: '레이저 마킹',
      categoryId: 'marking',
      description: '사진을 나무에 정밀하게 각인'
    },
    {
      id: 14,
      image: 'https://readdy.ai/api/search-image?query=laser%20engraved%20metal%20nameplate%20professional%20signage%20clean%20design%20industrial%20marking%20stainless%20steel%20plate%20custom%20engraving%20high%20quality%20finish%20modern%20style%20korean%20craftsmanship&width=800&height=600&seq=portfolio-marking-2&orientation=landscape',
      title: '금속 명패 각인',
      category: '레이저 마킹',
      categoryId: 'marking',
      description: '스테인리스 금속 명패 레이저 마킹'
    },
    {
      id: 15,
      image: 'https://readdy.ai/api/search-image?query=laser%20engraved%20leather%20diary%20notebook%20cover%20custom%20design%20professional%20photography%20clean%20background%20detailed%20marking%20pattern%20elegant%20style%20warm%20brown%20tones%20korean%20craftsmanship&width=800&height=600&seq=portfolio-marking-3&orientation=landscape',
      title: '다이어리 각인',
      category: '레이저 마킹',
      categoryId: 'marking',
      description: '가죽 다이어리 맞춤 각인'
    },
    {
      id: 16,
      image: 'https://readdy.ai/api/search-image?query=laser%20engraved%20acrylic%20signboard%20modern%20design%20professional%20photography%20clean%20background%20clear%20material%20custom%20marking%20contemporary%20style%20korean%20design&width=800&height=600&seq=portfolio-marking-4&orientation=landscape',
      title: '아크릴 간판',
      category: '레이저 마킹',
      categoryId: 'marking',
      description: '아크릴 소재 레이저 마킹 간판'
    },
    {
      id: 17,
      image: 'https://readdy.ai/api/search-image?query=laser%20engraved%20wooden%20coaster%20set%20custom%20design%20professional%20photography%20clean%20background%20detailed%20marking%20pattern%20natural%20wood%20texture%20warm%20tones%20korean%20craftsmanship&width=800&height=600&seq=portfolio-marking-5&orientation=landscape',
      title: '차받침 각인',
      category: '레이저 마킹',
      categoryId: 'marking',
      description: '원목 차받침 레이저 각인'
    },
    {
      id: 18,
      image: 'https://readdy.ai/api/search-image?query=laser%20engraved%20parking%20permit%20sign%20metal%20plate%20professional%20photography%20clean%20background%20industrial%20marking%20durable%20finish%20modern%20design%20korean%20quality&width=800&height=600&seq=portfolio-marking-6&orientation=landscape',
      title: '주차판 각인',
      category: '레이저 마킹',
      categoryId: 'marking',
      description: '금속 주차판 레이저 마킹'
    }
  ];

  const filteredItems = activeCategory === 'all' 
    ? portfolioItems 
    : portfolioItems.filter(item => item.categoryId === activeCategory);

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {filteredItems.map((item) => (
          <div
            key={item.id}
            className="group cursor-pointer"
            onClick={() => setSelectedImage(item)}
          >
            <div className="relative overflow-hidden rounded-xl bg-slate-100 aspect-[4/3] shadow-md hover:shadow-2xl transition-all duration-300">
              <div className="w-full h-full">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="w-16 h-16 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full">
                  <i className="ri-search-line text-3xl text-white"></i>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <div className="text-sm font-semibold text-amber-400 mb-1">{item.category}</div>
                <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                <p className="text-sm text-slate-200">{item.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {filteredItems.length === 0 && (
        <div className="text-center py-20">
          <i className="ri-folder-open-line text-6xl text-slate-300 mb-4"></i>
          <p className="text-xl text-slate-500">해당 카테고리의 작업물이 없습니다.</p>
        </div>
      )}

      {selectedImage && (
        <ImageModal 
          item={selectedImage} 
          onClose={() => setSelectedImage(null)} 
        />
      )}
    </>
  );
}
